import axios from "axios";

export const getAllProjects = () => {
  return axios.get(`/projects/?page=${1}`);
};

export const getProject = (projectID) => {
  return axios.get(`/projects/${projectID}/`);
};

export const createProject = (projectData, projectImage, accessToken) => {
  const formData = new FormData();
  formData.append("title", projectData.title);
  formData.append("description", projectData.description);
  formData.append("category", projectData.category);
  formData.append("goal_amount", Number(projectData.goal_amount));
  formData.append("start_date", projectData.start_date);
  formData.append("end_date", projectData.end_date);
  formData.append("image", projectImage);

  const headers = {
    "Content-Type": "multipart/form-data",
    Authorization: `Bearer ${accessToken}`,
  };

  return axios.post(`/projects/`, formData, { headers });
};

export const donate = ({ projectID, amount }) => {
  return axios.post("/pledges/", {
    project: projectID,
    amount: Number(amount),
  });
};
